/**
 * index.jsx
 *
 * @Author: jruif
 * @Date: 2018/2/9 下午3:54
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'neatui';
import './loading.scss';

class Loading extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    const { children, className, show, ...other } = this.props;
    return (
      <div
        className={classNames(
          'loading-box',
          {
            'loading-show': show,
          },
          className,
        )}
        {...other}>
        {React.Children.map(children, child =>
          React.cloneElement(child, {
            className: classNames(child.props.className, `loading-content`),
          }),
        )}
        <div className="loading">
          <Icon type="loading" />
          <span>加载中...</span>
        </div>
      </div>
    );
  }
}

export default Loading;
